function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useSelector } from 'react-redux';
import { convertedPrice } from 'researcher/helpers/price';
import { getChinaLocalization } from 'shared/account/reducer';
import { getAvailableNewPlans, getPaddlePrices, isPaddlePricesLoading } from '../../../reducer';
import { PADDLE_PLAN_TYPES } from '../../../constants';
import formatMoney from '../formatMoney';
var findByInterval = function findByInterval(plans, interval) {
  return plans.find(function (plan) {
    return plan.billingInterval === interval;
  });
};
var useRowPlanPricing = function useRowPlanPricing() {
  var currency = useSelector(function (_ref) {
    var user = _ref.user;
    return user.currency;
  });
  var isChinaUser = useSelector(getChinaLocalization);
  var paddlePrices = useSelector(getPaddlePrices);
  var loadingPaddlePrices = useSelector(isPaddlePricesLoading);
  var availablePlans = useSelector(getAvailableNewPlans);
  var getPlans = function getPlans(planGroup) {
    return availablePlans[planGroup] || [];
  };
  var getMoney = function getMoney(plan) {
    var paddlePrice = !loadingPaddlePrices && paddlePrices[plan.paddlePlanId];
    if (paddlePrice) {
      return {
        amount: paddlePrice.amount,
        symbol: paddlePrice.currencySymbol
      };
    }
    return {
      amount: convertedPrice(currency, plan.price, !isChinaUser),
      symbol: currency.sign
    };
  };
  var getSubscriptionPricing = function getSubscriptionPricing(planGroup, billingInterval) {
    var plans = getPlans(planGroup);
    var monthlyPlan = findByInterval(plans, PADDLE_PLAN_TYPES.MONTHLY);
    var yearlyPlan = findByInterval(plans, PADDLE_PLAN_TYPES.YEARLY);
    var isAnnual = billingInterval === PADDLE_PLAN_TYPES.YEARLY;
    var selectedPlan = isAnnual ? yearlyPlan : monthlyPlan;
    if (!selectedPlan) {
      return {
        selectedPlan: null,
        amount: 0,
        monthlyPrice: null,
        yearlySavings: null,
        discountPercent: 0
      };
    }
    var selected = getMoney(selectedPlan);
    var monthlyPrice = formatMoney(_objectSpread(_objectSpread({}, selected), {}, {
      amount: isAnnual ? selected.amount / 12 : selected.amount
    }));
    var yearlySavings = null;
    var discountPercent = 0;
    if (monthlyPlan && yearlyPlan) {
      var monthly = getMoney(monthlyPlan);
      var yearly = getMoney(yearlyPlan);
      var savingsAmount = monthly.amount * 12 - yearly.amount;
      if (savingsAmount > 0) {
        discountPercent = Math.floor(savingsAmount / (monthly.amount * 12) * 100);
        if (isAnnual) {
          yearlySavings = formatMoney({
            amount: savingsAmount,
            symbol: yearly.symbol
          });
        }
      }
    }
    return {
      selectedPlan: selectedPlan,
      amount: selected.amount,
      monthlyPrice: monthlyPrice,
      yearlySavings: yearlySavings,
      discountPercent: discountPercent
    };
  };
  var getOneTimePricing = function getOneTimePricing(planGroup) {
    var _getPlans = getPlans(planGroup),
      _getPlans2 = _slicedToArray(_getPlans, 1),
      plan = _getPlans2[0];
    return plan ? formatMoney(getMoney(plan)) : null;
  };
  return {
    getSubscriptionPricing: getSubscriptionPricing,
    getOneTimePricing: getOneTimePricing
  };
};
export default useRowPlanPricing;